export default __webpack_public_path__ + "static/media/tutorialWeb-4.3.9df35db7.png";